import React, { useCallback, useEffect, useMemo, Fragment } from 'react';
import PropTypes from 'prop-types';
import { Button, Descriptions, Row, Table } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import withStyles from 'react-jss';
import { FileDoneOutlined } from '@ant-design/icons';
import moment from 'moment';

import { clearWorkerIssue, getWorkerIssue } from '../Actions';
import Breadcrumbs from '../Components/Breadcrumbs';
import styles from '../styles';
import constants from '../constants';
import Api from '../Api';
import { errorNotification, successNotification } from '../Snackbar';

const ShowWorkerIssue = props => {
  const { match, classes } = props;
  const dispatch = useDispatch();

  const workerIssue = useSelector(state => state.workerIssue);
  const auth = useSelector(state => state.auth);

  useEffect(() => {
    dispatch(getWorkerIssue(match.params.id));
    return () => {
      dispatch(clearWorkerIssue());
    };
  }, []);

  const onApprove = useCallback(async () => {
    try {
      await Api.put(`/worker-jobs/issues/${match.params.id}/approve`);
      successNotification('Job approved');
      dispatch(getWorkerIssue(match.params.id));
    } catch (err) {
      errorNotification(err);
    }
  }, [match.params.id]);

  const scroll = useMemo(() => ({ x: 1900 }), []);
  const stylesRowKey = useCallback(record => record.id, []);

  const stylesColumns = useMemo(() => {
    const _columns = [
      {
        title: 'Customer',
        dataIndex: 'customer',
      },
      {
        title: 'BPO #',
        dataIndex: 'bpoNo',
      },
      {
        title: 'Product',
        dataIndex: 'product',
      },
      {
        title: 'Style',
        dataIndex: 'style',
      },
      {
        title: 'Description',
        dataIndex: 'styleDescription',
      },
      {
        title: 'Size',
        dataIndex: 'styleSize',
      },
      {
        title: 'Color',
        children: [
          {
            title: 'Base',
            dataIndex: 'baseColor',
          },
          {
            title: 'Print',
            dataIndex: 'printColor',
          },
          {
            title: 'Embroidery',
            dataIndex: 'embroideryColor',
          },
          {
            title: 'Acid Wash',
            dataIndex: 'acidWashColor',
          },
        ],
      },
      {
        title: 'Quantity',
        dataIndex: 'quantity',
      },
      {
        title: 'Remark',
        dataIndex: 'remark',
      },
    ];

    return _columns;
  }, []);

  return (
    <>
      <Breadcrumbs
        moduleName="Worker Issue Styles"
        moduleLink="/workers/issues"
        subModuleName="View Worker Issue Styles"
      />
      <div className={classes.tableStyle}>
        <Descriptions column={2} size="small" bordered>
          <Descriptions.Item label="Receive/Job time">
            {moment(workerIssue.jobTime).format('DD MMM YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="Remark">
            {workerIssue.remark}
          </Descriptions.Item>
          <Descriptions.Item label="Created By">
            {workerIssue.createdBy}
          </Descriptions.Item>
          <Descriptions.Item label="Created At">
            {moment(workerIssue.createdAt).format('DD MMM YYYY')}
          </Descriptions.Item>
          <Descriptions.Item label="Approved By">
            {workerIssue.approvedBy || 'Not approved'}
          </Descriptions.Item>
          <Descriptions.Item label="Approved At">
            {workerIssue.approvedAt
              ? moment(workerIssue.approvedAt).format('DD MMM YYYY')
              : null}
          </Descriptions.Item>
        </Descriptions>
        <br />
        {workerIssue.styles?.length && (
          <>
            <Table
              bordered
              size="small"
              columns={stylesColumns}
              dataSource={workerIssue.styles}
              rowKey={stylesRowKey}
              pagination={false}
              scroll={scroll}
              title={() => 'Product Table'}
            />
          </>
        )}
        <br />
        {!workerIssue.isApproved &&
          auth.permissions.includes(constants.permissions.approveWorkerJob) && (
            <Row>
              <Button
                className={classes.marginBetweenSelect}
                onClick={onApprove}
                icon={<FileDoneOutlined />}
              >
                Authorize
              </Button>
            </Row>
          )}
      </div>
    </>
  );
};

ShowWorkerIssue.propTypes = {
  classes: PropTypes.object.isRequired,
  match: PropTypes.object.isRequired,
};

export default withStyles(styles)(ShowWorkerIssue);
